import { postRequest } from '@/core';
import { cargoCarriers } from '@/requests';

export default async function syncCargoCarriers() {
	let url = cargoCarriers.getSyncPath();
	try {
		let response = await postRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}